import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'app',
    fieldName: '类型'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'host',
    fieldName: '请求Host'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'url',
    fieldName: '请求地址'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'ip',
    fieldName: '请求IP地址'
  }, {
    componentType: 'el-input',
    componentName: '下拉选择',
    fieldKey: 'method',
    fieldName: '请求方法'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'referer',
    fieldName: '请求页面'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createUser',
    fieldName: '用户'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'parameters',
    fieldName: '请求参数'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'body',
    fieldName: '请求数据'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createTime',
    fieldName: '创建时间'
  }
]
